import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { createStoreHook } from "@faire/web--source/ui/hooks/useStore";
import { History, createBrowserHistory } from "history";

export class AppHistory {
  static get = singletonGetter(AppHistory);

  history: History = createBrowserHistory();
}
export const useAppHistory = createStoreHook(AppHistory);
